import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { AccountSingleSearchFilter } from 'src/common/components/Filters/Inputs/accounts/AccountSingleSearchFilter';
import { useIsCslUser } from 'src/auth/hooks/useIsCslUser';
import { dashboardAccountAtom } from 'src/atoms/filters/dashboard';
import { dashboardAccountsHintsAtom, dashboardUpdateHintsAtom } from 'src/atoms/hints/dashboard';
import { FilledAutocompleteWrapper } from 'src/common/components/Inputs/Autocomplete/FilledAutocompleteWrapper';
import { useSetAtom } from 'jotai';

const AutocompleteContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(5),
  alignItems: 'center',
}));

export const DashboardAccountSelect = () => {
  const isCslUser = useIsCslUser();
  const setHints = useSetAtom(dashboardUpdateHintsAtom);

  const { t } = useTranslation();

  if (!isCslUser) {
    return null;
  }

  return (
    <AutocompleteContainer>
      <Typography color="text.secondary" variant="text2">
        {t('dashboard.accountFilter')}:
      </Typography>
      <FilledAutocompleteWrapper>
        <AccountSingleSearchFilter
          accountsFilterAtom={dashboardAccountAtom}
          accountsHintsAtom={dashboardAccountsHintsAtom}
          onAccountSelected={(option) => {
            if (option !== null && option.id !== null) {
              setHints({ accounts: [option.id] });
            }
          }}
        />
      </FilledAutocompleteWrapper>
    </AutocompleteContainer>
  );
};
